import {Nullable} from 'favorlogic-utils';

const days = ['NE', 'PO', 'ÚT', 'ST', 'ČT', 'PÁ', 'SO'];

export const getDayAbbreviation = (date: Nullable<string>): string | undefined =>
    date ? days[new Date(date).getDay()] : undefined;
